var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5C0 2.29086 1.79086 0.5 4 0.5H26C28.2091 0.5 30 2.29086 30 4.5V26.5C30 28.7091 28.2091 30.5 26 30.5H4C1.79086 30.5 0 28.7091 0 26.5V4.5Z",
    fill: "#6054BB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4102 18.09C22.4102 22.1827 19.0924 25.5004 15.0002 25.5004C14.7462 25.5004 14.4952 25.4875 14.2477 25.4627C14.2462 25.4627 14.2442 25.4621 14.2427 25.4621C10.5059 25.0829 7.58978 21.9267 7.58978 18.09C7.58978 15.053 9.4174 12.443 12.0324 11.2988V7.89258H17.9676V11.2988C20.583 12.443 22.4102 15.053 22.4102 18.09Z",
    fill: "#8ED7E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2427 25.4618C10.5059 25.0826 7.58978 21.9264 7.58978 18.0896C7.58978 15.0527 9.4174 12.4427 12.0324 11.2985V8.35059H12.7163V11.2986C10.9081 12.4427 9.39556 15.0527 9.39556 18.0897C9.39556 21.9259 11.6596 25.0811 14.2427 25.4618Z",
    fill: "#7CC3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9676 7.89258V8.89961C17.9015 8.90906 17.8339 8.91402 17.7648 8.91402H12.2352C12.1661 8.91402 12.0985 8.90906 12.0323 8.89961V7.89258H17.9676Z",
    fill: "#7CC3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7649 8.3502H12.2353C11.4482 8.3502 10.8102 7.71215 10.8102 6.92512C10.8101 6.13805 11.4482 5.5 12.2353 5.5H17.7649C18.5519 5.5 19.1899 6.13805 19.1899 6.92508C19.19 7.71215 18.5519 8.3502 17.7649 8.3502Z",
    fill: "#8ED7E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0965 6.92508C13.0965 6.13805 13.7346 5.5 14.5217 5.5H12.2353C11.4482 5.5 10.8102 6.13805 10.8102 6.92508C10.8102 7.71215 11.4482 8.35016 12.2353 8.35016H14.5217C13.7346 8.3502 13.0965 7.71215 13.0965 6.92508Z",
    fill: "#7CC3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3723 18.09C20.3723 18.4821 20.3301 18.8644 20.2495 19.2327C18.811 20.2854 17.148 20.3898 16.392 20.2191C15.4199 19.9996 14.3706 19.2913 15.0003 18.09C16.3224 17.5273 17.645 16.9646 20.249 16.9473C20.3301 17.318 20.3723 17.7007 20.3723 18.09Z",
    fill: "#D37250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2496 19.2327C19.7247 21.6479 17.5705 23.4625 15.0003 23.4625C12.0379 23.4625 9.62769 21.0524 9.62769 18.09C9.62769 17.7008 9.66995 17.318 9.75097 16.9473C12.3555 16.9646 13.6781 17.5273 15.0003 18.09C16.3224 18.6527 17.6451 19.2158 20.2496 19.2327Z",
    fill: "#E88158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2827 20.2114C12.6121 20.2114 12.8792 19.9444 12.8792 19.615C12.8792 19.2856 12.6121 19.0186 12.2827 19.0186C11.9533 19.0186 11.6863 19.2856 11.6863 19.615C11.6863 19.9444 11.9533 20.2114 12.2827 20.2114Z",
    fill: "#D37250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2982 21.9257C13.5795 21.9257 13.8074 21.6977 13.8074 21.4164C13.8074 21.1352 13.5795 20.9072 13.2982 20.9072C13.017 20.9072 12.789 21.1352 12.789 21.4164C12.789 21.6977 13.017 21.9257 13.2982 21.9257Z",
    fill: "#D37250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0493 21.8969C16.588 21.8969 17.0247 21.4603 17.0247 20.9216C17.0247 20.383 16.588 19.9463 16.0493 19.9463C15.5107 19.9463 15.074 20.383 15.074 20.9216C15.074 21.4603 15.5107 21.8969 16.0493 21.8969Z",
    fill: "#D37250"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon3);
export default __webpack_public_path__ + "static/media/ProjectIcon3.b5243cd8ca74a1b9f6171dbe0cdc3093.svg";
export { ForwardRef as ReactComponent };